<template>
  <div>
    <!-- Modal content here -->
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: "/images/publicView/feature-selection.svg",
    },
    title: {
      type: String,
      default: "Getting Started?"
    },
    description: {
      type: String,
      default: "By completing the registration form, you will get a free sneak preview of FixTrack with limited features"
    },
    redirectionRoute: {
      type: String,
      default: "https://app.fixtrack.com/register-tenant"
    }
  },
  methods: {
    openModal() {
      Swal.fire({
        imageUrl: this.imageUrl,
        imageHeight: 70,
        imageAlt: "",
        title: this.title,
        text: this.description,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonClass: "sweetalert-cancel-button-class",
        confirmButtonClass: "sweetalert-confirm-button-class btn-primary",
      }).then((result) => {
        if (result.value) {
          window.location = this.redirectionRoute;
        } else {
        
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
/* Your styles here */
</style>
